import { createSlice } from '@reduxjs/toolkit';

let nextId = 1;

/**
 * uiSlice — global UI state
 * Manages toast notifications and any future global UI state
 */
const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    toasts: [],
  },
  reducers: {
    addToast: (state, action) => {
      const { message, type = 'success', duration = 2000 } = action.payload;
      state.toasts.push({ id: nextId++, message, type, duration });
    },
    removeToast: (state, action) => {
      state.toasts = state.toasts.filter(t => t.id !== action.payload);
    },
    clearToasts: (state) => {
      state.toasts = [];
    },
  },
});

export const { addToast, removeToast, clearToasts } = uiSlice.actions;
export default uiSlice.reducer;

// ─── Selectors ──────────────────────────────────────────────────────────── //
export const selectToasts = state => state.ui.toasts;
